import { gql } from '__generated__';

export default gql(`
  mutation DeactivateEvent($id: ID!) {
    deactivateEvent(id: $id) {
      id
      active
    }
  }
`);
